"use client"
import React from 'react'
import useFetch from '@/app/useFetch'
import Link from 'next/link';
import { IMG_URL } from '@/app/config';
import { formatDateShort } from '@/app/helpers';
const LatestNewsPage = () => {

  const newsItems = [
    {
      date: "03",
      title: "Upholding Accountability: Vigilance Work Highlights  ",
      img: "/images/news1.jpg",
      year: "Jan 2024",
      desc: "Hon'ble Chief Minister Shri. Pinarayi Vijayan presenting the Best Police Station award for 2023 to the Kutippuram police station in the Malappuram district, which"
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
       {
      date: "03",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      year: "Jan 2024",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },
    {
      date: "03",
      year: "Jan 2024",
      title: "Upholding Accountability: Vigilance Work Highlights",
      img: "/images/news1.jpg",
      desc: "Chief Minister Pinarayi Vijayan presents the Police Station Award for 2023..."
    },

  ];

   //  const [page, setPage] = useState(1);
      const { data: list, loading, error } = useFetch(
          "/website/news-and-events-all",
          // { page, limit: 5 }, // pass page & limit here
          []
      );

  return (
    <>
      <div className="news-grid mt-40">
        {list.map((item, index) => (
          <Link href={`/latest-news-updates/${item.permalink}`}>
           <div className="news-card" key={index}>
            <div className="news-image">
              <img src={`${IMG_URL}${item.photo}`} alt={item.title} width={274} height={250} />
            </div>
            <div className="news-content">
              <span className="news-date"><span className='year'>{formatDateShort(item?.date)}</span></span>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
            </div>
          </div>
          </Link>
         
        ))}
      </div>

    </>
  )
}

export default LatestNewsPage
